import { render, staticRenderFns } from "./RespondentSetting.vue?vue&type=template&id=5f617c16&scoped=true&"
import script from "./RespondentSetting.vue?vue&type=script&lang=js&"
export * from "./RespondentSetting.vue?vue&type=script&lang=js&"
import style0 from "./RespondentSetting.vue?vue&type=style&index=0&id=5f617c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f617c16",
  null
  
)

export default component.exports